export const init = () => {

  // TRACKER 'MY STORE'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.customer.store);

  // firstChooseStore
  const firstChooseStore = new AnalyticsClickEvent('menu-firstChooseStore', tracker.defaultEvent());
  firstChooseStore.domElement = '.ua-content.empty-content a';
  firstChooseStore.options.label = 'FirstChooseStore';
  tracker.addEvent(firstChooseStore);

  // storeItinerary
  const storeItinerary = new AnalyticsClickEvent('storeItinerary', tracker.defaultEvent());
  storeItinerary.domElement = '#itinary-mystore';
  storeItinerary.options.label = 'Itinerary';
  tracker.addEvent(storeItinerary);

  // storeAllInfo
  const storeAllInfo = new AnalyticsClickEvent('storeAllInfo', tracker.defaultEvent());
  storeAllInfo.domElement = '.edit-options a:nth-child(1)';
  storeAllInfo.options.label = 'Informations';
  tracker.addEvent(storeAllInfo);

  // storeChange
  const storeChange = new AnalyticsClickEvent('storeChange', tracker.defaultEvent());
  storeChange.domElement = '.edit-options a:nth-child(2)';
  storeChange.options.label = 'Change';
  tracker.addEvent(storeChange);


  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

};



// WEBPACK FOOTER //
// ./src/analytics/trackers/customer/store-tracker.js